/**
 * RichTextDisplay - Renders HTML content from RichTextEditor
 * Handles inline styles for bullish/bearish formatting
 */
const RichTextDisplay = ({ 
  content, 
  darkMode = false,
  emptyMessage = 'No content yet.'
}) => {
  const isEmpty = !content || 
    content === '<p><br></p>' || 
    content === '<p></p>' ||
    content.trim() === '';

  if (isEmpty) {
    return (
      <div className={`italic ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={`rich-text-display ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <style>{`
        .rich-text-display {
          line-height: 1.6;
          text-align: left;
        }
        
        .rich-text-display p {
          margin-bottom: 0.5em;
        }
        
        .rich-text-display p:last-child {
          margin-bottom: 0;
        }
        
        .rich-text-display strong {
          font-weight: 600;
        }
        
        .rich-text-display em {
          font-style: italic;
        }
        
        .rich-text-display u {
          text-decoration: underline;
        }
        
        .rich-text-display s {
          text-decoration: line-through;
        }
        
        .rich-text-display h1 {
          font-size: 1.5em;
          font-weight: 700;
          margin-bottom: 0.5em;
        }
        
        .rich-text-display h2 {
          font-size: 1.25em;
          font-weight: 600;
          margin-bottom: 0.5em;
        }
        
        .rich-text-display h3 {
          font-size: 1.1em;
          font-weight: 600;
          margin-bottom: 0.5em;
        }
        
        .rich-text-display ul,
        .rich-text-display ol {
          padding-left: 1.5em;
          margin-bottom: 0.5em;
        }
        
        .rich-text-display ul {
          list-style-type: disc;
        }
        
        .rich-text-display ol {
          list-style-type: decimal;
        }
        
        .rich-text-display li {
          margin-bottom: 0.25em;
        }
        
        .rich-text-display .ql-align-center {
          text-align: center;
        }
        
        .rich-text-display .ql-align-right {
          text-align: right;
        }
        
        .rich-text-display .ql-align-justify {
          text-align: justify;
        }
        
        /* Dark mode */
        .rich-text-display.dark-mode {
          color: #D1D5DB;
        }
        
        .rich-text-display.dark-mode h1,
        .rich-text-display.dark-mode h2,
        .rich-text-display.dark-mode h3 {
          color: #F3F4F6;
        }
        
        .rich-text-display.dark-mode blockquote {
          border-left: 4px solid #3B82F6;
          padding-left: 12px;
          color: #9CA3AF;
          background: rgba(59, 130, 246, 0.1);
          margin: 8px 0;
          padding: 8px 12px;
          border-radius: 0 4px 4px 0;
        }
        
        .rich-text-display.dark-mode pre {
          background: rgba(0, 0, 0, 0.4);
          color: #10B981;
          padding: 16px;
          border-radius: 8px;
          overflow-x: auto;
          margin: 8px 0;
          font-family: 'Consolas', 'Monaco', 'Fira Code', monospace;
          font-size: 13px;
          border: 1px solid rgba(75, 85, 99, 0.5);
          white-space: pre-wrap;
        }
        
        /* Light mode */
        .rich-text-display.light-mode {
          color: #374151;
        }
        
        .rich-text-display.light-mode h1,
        .rich-text-display.light-mode h2,
        .rich-text-display.light-mode h3 {
          color: #111827;
        }
        
        .rich-text-display.light-mode blockquote {
          border-left: 4px solid #3B82F6;
          padding-left: 12px;
          color: #6B7280;
          background: rgba(59, 130, 246, 0.05);
          margin: 8px 0;
          padding: 8px 12px;
          border-radius: 0 4px 4px 0;
        }
        
        .rich-text-display.light-mode pre {
          background: #F3F4F6;
          color: #059669;
          padding: 16px;
          border-radius: 8px;
          overflow-x: auto;
          margin: 8px 0;
          font-family: 'Consolas', 'Monaco', 'Fira Code', monospace;
          font-size: 13px;
          border: 1px solid #E5E7EB;
        }
        
        /* Preserve inline styles from Quill (bullish/bearish colors) */
        .rich-text-display span[style] {
          padding: 2px 4px;
          border-radius: 3px;
        }
      `}</style>
      <div 
        className="rich-text-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default RichTextDisplay;
